export const NARROW_TILE_MAX_WIDTH = 290;
export const NARROW_TILE_RELEASE_WIDTH = 310;
export const CROWDED_MIN_FEEDS = 5;

export interface QualityBands {
  narrowTile: boolean;
  crowded: boolean;
}

// The tile band is entered at its threshold but left only past a release margin: every quality
// switch costs the publisher a keyframe, so a tile hovering on 290 px must not flap it. The feed
// count gets no margin: it includes screenshare feeds, so one would latch a four-camera room low
// after a share ends.
export class SimulcastQualityBands {
  private narrowTile = false;

  private measured = false;

  evaluate(tileWidth: number, feedsWithVideo: number): QualityBands {
    const next = this.peek(tileWidth, feedsWithVideo);

    if (tileWidth > 0) {
      this.measured = true;
      this.narrowTile = next.narrowTile;
    }

    return next;
  }

  // What `evaluate` would answer, for a count that may never be confirmed (a subscribe that fails).
  peek(tileWidth: number, feedsWithVideo: number): QualityBands {
    const measured = this.measured || tileWidth > 0;
    const narrowTile =
      tileWidth > 0
        ? tileWidth <= NARROW_TILE_MAX_WIDTH ||
          (this.narrowTile && tileWidth < NARROW_TILE_RELEASE_WIDTH)
        : this.narrowTile;

    return {
      // Until the layout has been measured the tile is treated as narrow without that counting
      // as a crossing, so the first real width is not mistaken for a return from below.
      narrowTile: !measured || narrowTile,
      crowded: feedsWithVideo >= CROWDED_MIN_FEEDS,
    };
  }
}
